import team1 from "../../Images/team-1.png";
import team2 from "../../Images/team-2.png";
import team3 from "../../Images/team-3.png";
import team4 from "../../Images/team-4.png";
import team5 from "../../Images/team-5.png";
import team6 from "../../Images/team-6.png";
import team7 from "../../Images/team-7.png";
import team8 from "../../Images/team-8.png";
import team9 from "../../Images/team-9.png";
import {
    FaTwitter,
    FaFacebookF,
    FaLinkedinIn,
    FaInstagram,
    FaShareAlt,
  } from "react-icons/fa";

export const TeamData = [
    {
        id : 1,
        name : "Jacob Reyes",
        img : team1,
        title : "CEO and Founder",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : "#"
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 2,
        name : "Sunny Deol",
        img : team2,
        title : "Co-ordinator",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 3,
        name : "Monaj Shins",
        img : team3,
        title : "Assistant Director",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 4,
        name : "keterina sissi",
        img : team4,
        title : "Brake Repairer",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 5,
        name : "Grabial Doe",
        img : team5,
        title : "Truck Mechanic",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 6,
        name : "John Marshal",
        img : team6,
        title : "Apprentice Repairer",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 7,
        name : "Methew White",
        img : team7,
        title : "Trolley Enginer",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 8,
        name : "Juilian Heart",
        img : team8,
        title : "Main Mechanic",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
    {
        id : 9,
        name : "Danial Sana",
        img : team9,
        title : "Enginner",
        shareIcon : <FaShareAlt/>,
        social : [
            {
                icon : <FaInstagram/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
        ]
    },
]